import { RecipientDto as NotificationRecipientDto } from 'src/api/FiretrolApiClient';

/** @registry Returns true when any recipient is external — a client contact (contactId set) or a free-text address (no userId) — so the customer-facing template must be used. */
export const hasExternalRecipient = (
  recipients: readonly NotificationRecipientDto[],
): boolean =>
  recipients.some(
    (recipient) => recipient.contactId != null || recipient.userId == null,
  );
